import { PaymentsProvider } from '@zorro/clients';
import { Badge, BadgeColor } from '@zorro/design-system/v2/Badge';
import { $enum } from 'ts-enum-util';

const getPaymentsProviderBadgeConfig = (paymentsProvider: PaymentsProvider) =>
  $enum.mapValue(paymentsProvider).with<{
    label: string;
    color: BadgeColor;
  }>({
    [PaymentsProvider.LYNX]: { label: 'Lynx', color: 'green' },
    [PaymentsProvider.ECHO]: { label: 'Echo', color: 'orange' },
  });

type Props = {
  paymentsProvider: PaymentsProvider;
};

export const PaymentsProviderBadge = ({ paymentsProvider }: Props) => {
  const { label, color } = getPaymentsProviderBadgeConfig(paymentsProvider);

  return (
    <Badge variant="simple" color={color}>
      {label}
    </Badge>
  );
};
